// extracted by mini-css-extract-plugin
module.exports = {"total_inverters":"total_inverters--2SB-e","map":"map--1eXEt"};